var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.loading && _setup.workflow)?_c(_setup.GridInvocation,{attrs:{"filtered-for":{
        type: 'StoredWorkflow',
        id: _setup.workflow.id,
        name: _setup.workflow.name,
    }}}):(_setup.loading)?_c(_setup.BAlert,{attrs:{"variant":"info","show":""}},[_c(_setup.LoadingSpan,{attrs:{"message":"Loading invocations for workflow"}})],1):_c(_setup.BAlert,{attrs:{"variant":"danger","show":""}},[_c('p',[_vm._v("Failed to load stored workflow with ID: "+_vm._s(_setup.props.storedWorkflowId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }